import { useState } from 'react';

import { ActionButton } from 'commonComponents/ActionButton';

import { DeleteIcon } from 'icons';
import { ROLE_DEFINITIONS } from 'roles/definitions';
import { RoleDependentComponent } from 'roles/RoleDependentComponent';

import { LicenseDeleteDialog } from './LicenseDeleteDialog';

export function LicenseDeleteButton({ licenseDetails }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <RoleDependentComponent
                userRole={ROLE_DEFINITIONS.LicenseManager}
                component={ActionButton}
                onClick={() => setOpen(true)}
                color="secondary"
                iconClass={DeleteIcon}
                title="Delete"
                variant="contained"
            />
            <LicenseDeleteDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                licenseId={licenseDetails.id}
            />
        </>
    );
}
